import React from "react";
import {Route,HashRouter,Redirect} from 'react-router-dom';
import Content from './components/content';
import PayList from './components/paylist';
import PaySlip from "./components/payslip";
import IncomeTax from "./components/incometax";
import Fuel from "./components/fuel";
import Repair from "./components/repair";
import Leave from "./components/leave";
import Medical from "./components/Medical";
import MedicalFormPrevious from "./components/medical_formPrevious";
import MedicalClaimListPrevious from "./components/MedicalClaimListPrevious";
import MedicalClaimList from "./components/MedicalClaimList";
import Medicalapp from "./components/medical_form";
import MedicalFormEdit from "./components/MedicalFormEdit";
//import Medical_Claims_Detail from "./components/MedicalDetail";
import Notification from "./components/Notifications";
import Contacts from "./components/contacts";
import Profile from "./components/profile";
//import News from "./components/News";
import MedicalForm from "./components/medicalform";
import LeaveApplication from "./components/LeaveApplication";
import LeaveapplicationOther from "./components/LeaveapplicationOther";
import LeaveapplicationSelf from "./components/LeaveapplicationSelf";
import LeaveAppList from "./components/leaveapplist";
import AdminMedicalTab from "./components/AdminMedical";
import AdminMedicalTabAbt from "./components/AdminMedicalAbt";
import AdminMedicalTabWah from "./components/AdminMedicalWah";
import LeaveManager from "./components/AdminLeaveManager";
import AdminLeaveManagement from "./components/AdminLeaveManagement";
import AdminLeavesDetail from "./components/AdminLeavesDetail";
import leaverevoke from "./components/LeaveRevoke";
import AdminNotificationTab from "./components/AdminNotification";
import AdminNews from "./components/AdminNews";
import LabTabs from "./components/tabs";
import FuelReceipt from "./components/fuelreceipt";
import Holidays from "./components/holidays";
import Home from "./components/home";
import Attendance from "./components/Attendance";
import Daily_attendance from "./components/Daily_attendance";
import VirtualAttendance from "./components/VirtualAttendance";
import App from "./App";
import "./components/header/Header.css";
import HeaderTop from "./components/top";
//import logopassword from "./components/images/change-password.png";
import Cookies from "universal-cookie";
//import VCQRcode from "./components/VCQRcode";
import Monthly_attendance from "./components/Monthly_attendance";
import EmployeeAttendance from "./components/EmployeeAttendance";
import Taxcertificate from "./components/Taxcertificate";
import LeaveCompensatory from "./components/LeaveCompensatory";
import MedicalClaimListother from "./components/MedicalClaimListother";
import MedicalClaimListPreviousother from "./components/MedicalClaimListPreviousother";
import MedicalDetailSelf from "./components/MedicalDetailSelf";
import MedicalDetailOther from "./components/MedicalDetailOther";
import AdminLeaveManagementABT from "./components/AdminLeaveManagementABT";
import AdminLeaveManagementWAH from "./components/AdminLeaveManagementWAH";
import Medicalchart from "./components/Medicalchart";
import PR from "./components/pr";
import AttendanceDuringDate from "./components/AttendanceDuringDate";
import Monthly_attendance_date from "./components/Monthly_attendance_date";
import AdminFuelMonthWise from "./components/AdminFuelMonthWise";
import AdminVehRepair from "./components/AdminVehRepair";
import AdminVehicleupkeep from "./components/AdminVehicleupkeep";
import EnginOil from "./components/EnginOil";
import B_form from "./components/B_form";
const cookies = new Cookies();
const createBrowserHistory =require("history").createBrowserHistory; 
const customHistory = createBrowserHistory();
const CustomRoutes = ()=>
    <HashRouter history={customHistory} >
        <App/>
        <Route path="/content/" component={Content}/>
        <Route path="/paylist/" component={PayList} />
        <Route path="/payslip/" component={PaySlip}/>
        <Route path="/incometax/" component={IncomeTax}/>
        <Route exact path="/fuel/" component={Fuel}/>
        <Route exact path="/repair/" component={Repair}/>
        <Route exact path="/leave/" component={Leave}/>
        <Route exact path="/medical_form/" component={Medicalapp}/>
        <Route exact path="/medical_formPrevious/" component={MedicalFormPrevious}/>
        <Route exact path="/MedicalClaimList/" component={MedicalClaimList}/>
        <Route path="/MedicalClaimListPrevious/" component={MedicalClaimListPrevious}/>

        <Route exact path="/Medical/" component={Medical}/>
        <Route exact path="/contacts/" component={Contacts}/>
        <Route exact path="/Notifications/" component={Notification}/>
        <Route path ="/profile/" component={Profile }/>
        <Route path ="/LeaveApplication" component={LeaveApplication}/>
        <Route path ="/LeaveapplicationSelf" component={LeaveapplicationSelf}/>
        <Route path ="/LeaveapplicationOther" component={LeaveapplicationOther}/>
        <Route path ="/LeaveRevoke" component={leaverevoke}/>
        <Route path ="/leaveapplist" component={LeaveAppList}/>
        <Route path ="/AdminMedical" component={AdminMedicalTab}/>
        <Route path ="/AdminMedicalAbt" component={AdminMedicalTabAbt}/>
        <Route path ="/AdminMedicalWah" component={AdminMedicalTabWah}/>
        <Route path ="/AdminLeaveManager" component={LeaveManager}/>
        <Route path ="/AdminNews" component={AdminNews}/>
        <Route path ="/AdminNotification" component={AdminNotificationTab}/>
        <Route path ="/fuelreceipt" component={FuelReceipt}/>
        <Route path ="/AdminLeaveManagement" component={AdminLeaveManagement}/>
        <Route path ="/AdminLeaveManagementABT" component={AdminLeaveManagementABT}/>
        <Route path ="/AdminLeaveManagementWAH" component={AdminLeaveManagementWAH}/>
        <Route path ="/AdminLeavesDetail" component={AdminLeavesDetail}/>
        <Route path ="/medicalform" component={MedicalForm}/>
        <Route path="/holidays" component={Holidays}/>
        <Route path="/Attendance" component={Attendance}/>
        <Route path="/Daily_attendance" component={Daily_attendance}/>
        <Route path ="/tabs" component={LabTabs}/>
        <Route path ="/top" component={HeaderTop}/>
        <Route path ="/home" component={Home}/>
        <Route path="/MedicalFormEdit" component={MedicalFormEdit}/>
        <Route path="/Monthly_attendance" component={Monthly_attendance}/>
        <Route path="/EmployeeAttendance" component={EmployeeAttendance}/>
        <Route path="/Taxcertificate" component={Taxcertificate}/>
        <Route path="/VirtualAttendance" component={VirtualAttendance}/>
        <Route path="/LeaveCompensatory" component={LeaveCompensatory}/>
        <Route path="/MedicalClaimListother" component={MedicalClaimListother}/>
        <Route path="/MedicalClaimListPreviousother" component={MedicalClaimListPreviousother}/>

        <Route path="/MedicalDetailSelf" component={MedicalDetailSelf}/>
        <Route path="/MedicalDetailOther" component={MedicalDetailOther}/>

        <Route path="/Medicalchart" component={Medicalchart}/>
        <Route path="/pr" component={PR}/>
        <Route path="/AttendanceDuringDate" component={AttendanceDuringDate}/>
        <Route path="/Monthly_attendance_date" component={Monthly_attendance_date}/>
        <Route path="/AdminFuelMonthWise" component={AdminFuelMonthWise}/>
        <Route path="/AdminVehRepair" component={AdminVehRepair}/>
        <Route path="/AdminVehicleupkeep" component={AdminVehicleupkeep}/>
        <Route exact path="/EnginOil" component={EnginOil}/>
        <Route path ="/B_form/" component={B_form }/>


        <Redirect to="./home" />
    </HashRouter>
export default CustomRoutes;